import React, {useCallback} from "react";
import {useHistory} from "react-router";
import UILink from "~/old-ui/UILink";

export default function ReactLink({to, disabled, onClick, ...props}) {
  const history = useHistory();

  const onLinkClick = useCallback((e) => {
    if (disabled) return;

    onClick && onClick(e);

    if (!e.defaultPrevented) {
      e.preventDefault();
      history.push(to);
      return true;
    } else {
      return false;
    }
  }, [history, to, disabled]);

  return (
    <UILink
      href={to}
      disabled={disabled}
      onClick={onLinkClick}
      {...props}
    />
  )
}
